import baseAPI from '@/http'

const router = 'api/acompanhamento'

export const attendanceAPI = {
  create: (attendance) => baseAPI.post(router, attendance),
  update: (attendance) => baseAPI.put(router, attendance),
  get: (id) => baseAPI.get(`${router}/${id}`),
  list: (id) => baseAPI.get(`${router}/acompanhamentos/${id}`),
  getNovo: (id) => baseAPI.get(`${router}/acompanhamentos/novo/${id}`),
  finalizar: (attendance) => baseAPI.put(router + '/acompanhamentos/finalizar', attendance),
  getNovoTema: (id, temaId) => baseAPI.get(`${router}/acompanhamentos/novo/tema/${id}/${temaId}`),
  finalizacao: (id) => baseAPI.get(`${router}/acompanhamentos/finalizacao/${id}`),
  cutAttendance: (payload) => baseAPI.post(router + '/acompanhamentos/acompanhamento-intermediario', payload)
}
